import React from 'react';
import { Card } from 'react-bootstrap';
import { FaUser, FaClock, FaCloudDownloadAlt, FaComment } from 'react-icons/fa';

const icons = {
  user: FaUser,
  clock: FaClock,
  'cloud-download': FaCloudDownloadAlt,
  chat: FaComment,
};

const StatsCard = ({ title, value, icon, color }) => {
  const Icon = icons[icon];

  return (
    <Card
      className={`text-white bg-${color} shadow-sm mb-3 text-center border-0`}
      style={{ cursor: 'pointer', height: '150px' }} // Adjust the card height
    >
      <Card.Body className="d-flex flex-column justify-content-center align-items-center">
        <Icon size={30} className="mb-2" /> {/* Reduce icon size */}
        <div>
          <Card.Title className="h2 fw-bold mb-0">{value}</Card.Title> {/* Reduce font size */}
          <Card.Text className="fw-light">{title}</Card.Text>
        </div>
      </Card.Body>
    </Card>
  );
};

export default StatsCard;
